import { DEFAULT_SEARCH_COUNT, SearchRequest } from '@medplum/core';

export function addDefaultSearchValues(
  search: SearchRequest,
  defaultFields = ['_id', '_lastUpdated']
): SearchRequest {
  const fields = search.fields ?? defaultFields;
  const offset = search.offset ?? 0;
  const count = search.count ?? DEFAULT_SEARCH_COUNT;
  const sortRules = search.sortRules ?? [
    {
      code: '_lastUpdated',
      descending: true,
    },
  ];
  return {
    ...search,
    fields,
    offset,
    count,
    sortRules,
  };
}

/**
 * Creates a partial update object for search parameters with a dynamic key.
 *
 * Note: This uses a type assertion because TypeScript cannot verify computed
 * property keys at compile time. The assertion is safe as long as the key
 * is guaranteed to be a valid key of T.
 *
 * @param key - The property key to update
 * @param value - The value to set for the property
 * @returns A partial object with the specified key-value pair
 */
export function createSearchUpdate<T>(
  key: keyof T,
  value: unknown
): Partial<T> {
  return { [key]: value } as Partial<T>;
}
